import axios from 'axios';
import { Globals } from '@/modules/Globals';
import { PermissionType } from '@/enums/PermissionType';

export interface IPosAdminGrantCreateResponse {
  grantId: string;
  code: string;
  expiresAtMs: number;
}

export interface IPosAdminGrantVerifyResponse {
  authorizedByUserId: number;
  authorizedByName: string;
  grantId: string;
  expiresAtMs: number;
}

export class PosAdminGrantsService {
  static async generate() {
    const res = await axios.post<IPosAdminGrantCreateResponse>(
      `${Globals.apiPath}/pos-admin-grants`
    );
    return res.data;
  }

  /** Redeems (verifies + consumes) a one-time admin token from the panel. */
  static async verify(
    restaurantId: number,
    code: string,
    requiredPermission: PermissionType
  ) {
    const res = await axios.post<IPosAdminGrantVerifyResponse>(
      `${Globals.apiPath}/pos-admin-grants/verify-admin`,
      { restaurantId, code, requiredPermission }
    );
    return res.data;
  }
}

